module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_5"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_35"
  }, [_c('img', {
    staticClass: "calibre9",
    attrs: {
      "alt": "Image",
      "src": "images/image-3.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_22"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_36"
  }, [_vm._v("From the beginning of time, secrets have been the advocates of darkness, stimulating the surreptitious thoughts of man.")]), _vm._v(" "), _c('p', {
    staticClass: "block_36"
  }, [_vm._v("Barroth, E. M.1722.—All Things Woven—London, ENG")]), _vm._v(" "), _c('p', {
    staticClass: "block_37",
    attrs: {
      "id": "calibre_pb_15"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-763fe681","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_009.vue
// module id = 90
// module chunks = 0